<template>
    <div :class="['card', { vertical }]" v-if="card">
        <div class="avatar">
            <Image v-if="card.cover" :image="(card.cover as Image)" :width="800" imageClass="cover" :key="card.cover.id" />
        </div>
        <div class="info" v-if="card.translations">
            <div class="title4">{{ card.translations[0]?.titolo }}</div>
            <div class="paragraph" v-if="card.translations[0]?.sottotitolo">
                <p>{{ card.translations[0]?.sottotitolo }}</p>
            </div>
            <div v-else></div>
            <div class="buttonCont" v-if="card.cta && card.tipologia_link == 'cta'">
                <WebsiteCTA :cta="card.cta" />
            </div>
            <div class="socialCont" v-else-if="card.social && card.tipologia_link == 'social'">
                <a v-for="social in card.social" :href="social.link" target="_blank" rel="nofollow noopener" :aria-label="social.icon">
                    <NButton size="medium" type="primary" circle aria-label="Social">
                        <template #icon>
                            <NIcon color="var(--color-text-default)" v-if="social.icon == 'facebook'" aria-label="Facebook">
                                <IconFacebook />
                            </NIcon>
                            <NIcon size="0.706rem" color="var(--color-text-default)" v-else-if="social.icon == 'twitter'" aria-label="Twitter">
                                <IconTwitter />
                            </NIcon>
                            <NIcon size="1rem" color="var(--color-text-default)" v-else-if="social.icon == 'instagram'" aria-label="Instagram">
                                <IconInstagram />
                            </NIcon>
                            <NIcon size="0.882rem" color="var(--color-text-default)" v-else-if="social.icon == 'tiktok'" aria-label="TikTok">
                                <IconTikTok />
                            </NIcon>
                            <NIcon color="var(--color-text-default)" v-else-if="social.icon == 'youtube'" aria-label="YouTube">
                                <IconYoutube />
                            </NIcon>
                            <NIcon size="0.941rem" color="var(--color-text-default)" v-else-if="social.icon == 'linkedin'" aria-label="LinkedIn">
                                <IconLinkedInGhost />
                            </NIcon>
                        </template>
                    </NButton>
                </a>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { NButton, NIcon } from 'naive-ui'
defineProps<{ card: any, vertical?: boolean }>()
</script>

<style lang="scss" scoped>
.card {
    background-color: var(--color-background-box);
    border-radius: var(--size-card-radius);

    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));

    min-height: 200px;
    overflow: hidden;

    .avatar {
        position: relative;
    }

    .info {
        padding: var(--margin-default);
        padding-left: var(--margin-double);
        display: grid;
        grid-template-rows: min-content 1fr min-content;
        gap: var(--margin-gap);
    }

    .socialCont {
        display: flex;
        gap: var(--margin-mini);
        flex-wrap: wrap;
    }

    .paragraph+.socialCont {
        margin-top: var(--margin-mini);
    }

    @media screen and (min-width: 601px) {
        &.vertical {
            grid-template-columns: 1fr;
            grid-template-rows: 200px 1fr;

            .info {
                padding-left: var(--margin-default);
            }
        }
    }
}

@media screen and (max-width: 600px) {
    .card {
        .info {
            padding: var(--margin-default);
        }
    }
}
</style>